import { useLang } from "@/context/LangContext";
import { useSettings } from "@/context/SettingsContext";

const TelegramIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden {...p}><path d="M9.78 15.27 9.6 19.4c.37 0 .53-.16.72-.35l1.73-1.66 3.59 2.63c.66.36 1.13.17 1.3-.61l2.36-11.07c.24-.98-.36-1.36-1-1.12L4.4 11.87c-.95.37-.94.9-.16 1.14l3.55 1.11 8.24-5.2c.39-.24.74-.11.45.15l-6.7 6.2Z" /></svg>
);
const WhatsAppIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden {...p}><path d="M12.04 2a9.9 9.9 0 0 0-8.5 14.97L2 22l5.17-1.5A9.9 9.9 0 1 0 12.04 2Zm5.8 14.02c-.24.68-1.42 1.3-1.96 1.35-.5.05-.98.24-3.3-.69-2.8-1.1-4.56-3.96-4.7-4.15-.14-.18-1.12-1.49-1.12-2.85s.71-2.02.97-2.3c.25-.27.55-.34.73-.34h.53c.17 0 .4-.06.62.48.24.56.8 1.94.86 2.08.07.14.12.3.02.48-.09.19-.14.3-.28.46-.14.17-.3.37-.42.5-.14.14-.29.29-.13.57.17.28.74 1.21 1.58 1.96 1.09.97 2 1.27 2.29 1.41.28.14.44.12.6-.07.17-.19.7-.82.89-1.1.18-.28.37-.23.62-.14.25.1 1.6.76 1.88.9.27.13.46.2.52.32.07.11.07.66-.17 1.33Z" /></svg>
);

export const telegramHref = (v) => {
  const s = (v || "").trim();
  if (!s) return "";
  if (s.startsWith("http")) return s;
  return `https://t.me/${s.replace(/^@/, "")}`;
};

export const whatsappHref = (v) => {
  const s = (v || "").trim();
  if (!s) return "";
  if (s.startsWith("http")) return s;
  return `https://wa.me/${s.replace(/\D/g, "")}`;
};

const BASE = "inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-bold transition-transform hover:scale-[1.03]";

export const SocialButtons = ({ variant = "solid", testPrefix = "social" }) => {
  const { t } = useLang();
  const { settings } = useSettings();
  const tg = telegramHref(settings?.telegram_link);
  const wa = whatsappHref(settings?.whatsapp_number);
  if (!tg && !wa) return null;
  const ghost = variant === "ghost";
  return (
    <div className="flex flex-wrap gap-3">
      {tg && (
        <a href={tg} target="_blank" rel="noreferrer" data-testid={`${testPrefix}-telegram-link`} className={`${BASE} ${ghost ? "border border-sky-400/40 bg-sky-400/10 text-sky-300" : "bg-[#229ED9] text-white"}`}>
          <TelegramIcon className="h-5 w-5" />{t("connect_telegram")}
        </a>
      )}
      {wa && (
        <a href={wa} target="_blank" rel="noreferrer" data-testid={`${testPrefix}-whatsapp-link`} className={`${BASE} ${ghost ? "border border-emerald-400/40 bg-emerald-400/10 text-emerald-300" : "bg-[#25D366] text-white"}`}>
          <WhatsAppIcon className="h-5 w-5" />{t("connect_whatsapp")}
        </a>
      )}
    </div>
  );
};
